module.exports = __webpack_public_path__ + "static/media/trc-logo.facaef5c.svg";